export default {
    /**
     * Sets Shop Drawing data on the state.
     *
     * @param state State object
     * @param data Data object
     */
    SET_SHOP_DRAWING: function (state, data) {
        state.revision = data.revision;
        state.options.leedProject = data.options.leed_project;
        state.options.request_types = data.options.request_types;
        state.timelineFirstPageUrl = data.timelineFirstPageUrl;
        state.options.difficultyLevels = data.options.difficulty_level_options;
    },

    /**
     * Sets Shop Drawing data on the state.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REJECTIONS_LIST: function (state, data) {
        state.options.rejections.splice(0, state.options.rejections.length, ...data);
    },

    /**
     * Sets Shop Drawing project info data on the state.
     *
     * @param state State object
     * @param data Data object
     */
    SET_SHOP_DRAWING_PROJECT_INFO: function (state, data) {
        state.projectInfo = data;
    },

    SET_PROJECT_NPD_TICKETS: function (state, data) {
        state.npdTickets = data
    },

    /**
     * Sets Shop Drawing draft value
     *
     * @param state State object
     * @param data Data object
     */
    SET_DRAFT: function (state, data) {
        state.revision.drafts.splice([data.index], 1, data.draftData);
    },

    /**
     * Appends Shop Drawing draft at the bottom
     *
     * @param state State object
     * @param draft Draft object
     */
    APPEND_DRAFT: function (state, draft) {
        state.revision.drafts.unshift(draft);
    },

    /**
     * Removes draft
     *
     * @param state State object
     * @param index draft index in array
     */
    REMOVE_DRAFT: function (state, index) {
        state.revision.drafts.splice(index, 1);
    },

    /**
     * Sets available drafters.
     *
     * @param state State object
     * @param data Data object
     */
    SET_DRAFTERS: function (state, data) {
        let drafters = [];
        if (data.length) {
            Object.values(data).map(drafter => {
                let userInfo = drafter.hasOwnProperty('user') ? drafter.user : drafter;
                userInfo.expected_durations_sum = drafter.expected_durations_sum || null;
                drafters.push(userInfo);
            });
        }
        state.options.drafters = drafters.sort((drafterA, drafterB) => drafterA.expected_durations_sum - drafterB.expected_durations_sum);
    },

    /**
     * Toggles signed Shop Drawing prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_SIGNED_SHOPS_PROMPT: function (state, data) {
        state.signedShopPromptOpen = data;
    },

    /**
     * Toggles cancel Shop Drawing prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CANCEL_SHOPS_PROMPT: function (state, data) {
        state.cancelShopPromptOpen = data;
    },

    /**
     * Toggles hold Shop Drawing prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_HOLD_SHOPS_PROMPT: function (state, data) {
        state.holdShopPromptOpen = data;
    },

    /**
     * Toggles Shop Drawing task info editing.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_TASK_INFO_EDIT: function (state, data) {
        state.editingTaskInfo = data;
    },

    SET_SINGLE_SHOP_DRAWINGS_LOADER: function (state, data) {
        state.showSignedShopsLoader = data;
    },

    /**
     * Sets project quotes.
     *
     * @param state State object
     * @param data Data object
     */
    SET_QUOTES: function (state, data) {
        state.options.quotes = data;
    },

    /**
     * Sets architectural drawings.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ARCHITECTURAL_DRAWINGS: function (state, data) {
        state.options.architecturalDrawings = data;
    },

    /**
     * Sets validation errors for task information changes.
     *
     * @param state State object
     * @param data Data object
     */
    SET_TASK_INFO_ERRORS: function (state, data) {
        state.errors.taskInfo = data;
    },

    /**
     * Sets Shop Drawing revision hold statuses.
     *
     * @param state State object
     * @param data Data object
     */
    SET_HOLD_STATUSES: function (state, data) {
        state.holdStatuses = data;
    },

    /**
     * Sets Unassigned action required count.
     *
     * @param state State object
     * @param data Data object
     */
    SET_UNASSIGNED_COUNT: function (state, data) {
        state.unassignedActionRequiredCount = 1 * data;
    },

    SET_ASSIGNED_COUNT: function (state, data) {
        state.assignedActionRequiredCount = 1 * data;
    },

    SET_WORKLOAD_COUNT: function (state, data) {
        state.workloadActionRequiredCount = 1 * data;
    },

    SET_SIGNED_SHOP_DRAWINGS: function (state, data) {
        state.signedShopDrawings = data;
    },

    /**
     * Sets Revision status.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REVISION_STATUS: function (state, data) {
        state.revision.status = data;
    },

    /**
     * Sets Revision planned due date.
     *
     * @param state State object
     * @param data Data object
     */
    SET_REVISION_PLANNED_DUE_DATE: function (state, data) {
        state.revision.planned_due_date = data;
    },

    /**
     * Sets Shop Drawing Revision Additional Requests data on the state.
     *
     * @param state State object
     * @param data Data object
     */
    SET_SHOP_DRAWING_ADDITIONAL_REQUESTS: function (state, data) {
        state.revision.additional_requests = data;
    },

    SET_SHOP_DRAWING_DIFFICULTY_LEVEL: function (state, data) {
        state.revision.difficulty_level = data;
    },
    /**
     * Sets Shop Drawing failed action information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FAILED_ACTION (state, data) {
        state.failedAction = data;
    },

    /**
     * Toggles cancel Shop Drawing prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CANCEL_SHOPS_ADDITIONAL_REQUEST_PROMPT: function (state, data) {
        state.cancelShopAdditionalRequestPromptOpen = data;
    },

    /**
     * Toggles new Shop Drawing request prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_NEW_SHOPS_REQUEST_PROMPT: function (state, data) {
        state.newShopRequestPromptOpen = data;
    },

    /**
     * Toggles link Shop Drawing request prompt.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_LINK_SHOPS_REQUEST_PROMPT: function (state, data) {
        if (data === false) {
            state.linkShopPromptOnlyInstDetails = false;
        }
        state.linkShopRequestPromptOpen = data;
    },
    /**
     *
     * @param state State object
     * @param data Data object
     */
    SHOW_IN_LINK_SHOP_MODAL_ONLY_INST_DETAILS: function (state, data) {
        state.linkShopPromptOnlyInstDetails = data;
    },

    /**
     *
     * Sets shop drawing list filters data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(data[keys[i]])) {
                state.shopsList.filters[keys[i]].splice(0, state.shopsList.filters[keys[i]].length, ...data[keys[i]]);
            } else {
                if (keys[i] === 'filter') {
                    let filter = data[keys[i]];
                    if ((filter instanceof String || typeof filter == 'string') && filter.length > 200) {
                        filter = filter.substring(0, 200);
                    }
                    state.shopsList.filters[keys[i]] = filter;
                } else {
                    state.shopsList.filters[keys[i]] = data[keys[i]];
                }
            }
        }
    },

    /**
     * Toggles shop drawing list filters sidebar.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_FILTER_SIDEBAR (state, data) {
        state.shopsList.filtersOpen = data;
    },

    /**
     * Removes single shop drawing list filter.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_FILTER (state, data) {
        for (let i = 0; i < state.shopsList.filters[data.field].length; i++) {
            if (state.shopsList.filters[data.field][i].id === data.id) {
                state.shopsList.filters[data.field].splice(i, 1);
            }
        }
    },

    /**
     * Toggles shops list refresh.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_LIST_REFRESH (state, data) {
        state.shopsList.refreshList = data;
    },

    /**
     * Toggles shop drawing action required filters sidebar.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_ACTION_REQUIRED_FILTER_SIDEBAR (state, data) {
        state.actionRequiredList.filtersOpen = data;
    },

    /**
     *
     * Sets shop drawing action required filters data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_REQUIRED_FILTERS_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(data[keys[i]])) {
                state.actionRequiredList.filters[keys[i]].splice(0, state.actionRequiredList.filters[keys[i]].length,
                    ...data[keys[i]]);
            } else {
                state.actionRequiredList.filters[keys[i]] = data[keys[i]];
            }
        }
    },

    /**
     * Removes single shop drawing action required filter.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_ACTION_REQUIRED_FILTER (state, data) {
        if (data.field === 'include_linked_requests') {
            state.actionRequiredList.filters[data.field] = false
        }
        for (let i = 0; i < state.actionRequiredList.filters[data.field].length; i++) {
            if (state.actionRequiredList.filters[data.field][i].id === data.id) {
                state.actionRequiredList.filters[data.field].splice(i, 1);
            }
        }
    },

    /**
     * Toggles shop drawing action required list refresh.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_ACTION_REQUIRED_LIST_REFRESH (state, data) {
        state.actionRequiredList.refreshList = data;
    },

    /**
     * Sets shops list filters information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_INFO (state, data) {
        state.filterData.drafters.splice(0, state.filterData.drafters.length, ...data.drafters);
        state.filterData.request_types.splice(0, state.filterData.request_types.length, ...data.request_types);
        state.filterData.statuses.splice(0, state.filterData.statuses.length, ...data.statuses);
        state.filterData.estimators.splice(0, state.filterData.estimators.length, ...data.estimators);
        state.filterData.po_owners.splice(0, state.filterData.po_owners.length, ...data.po_owners);
    },

    /**
     * Toggles DWG Generation preloader modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_DWG_GENERATION_MODAL: function (state, data) {
        state.dwgGenerationModalOpen = data;
    },

    /**
     * Toggles 3D Cad Generation preloader modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_3D_CAD_GENERATION_MODAL: function (state, data) {
        state.cadGenerationModalOpen = data;
    },
    TOGGLE_3D_CAD_REGENERATION_MODAL: function (state, data) {
        state.regenerateCadModalOpen = data;
    },

    /**
     * Toggles est dates generation modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_EST_DATE_CALCULATION_MODAL: function (state, data) {
        state.estDateCalculationModalOpen = data;
    },

    SET_LINKED_INST_DETAILS: function (state, data) {
        state.linkedInstDetails = data;
        if (data !== null) {
            state.linkedInstDetails.user = data.drafter ? data.drafter.full_name : '';
        }
    },

    SET_LINKED_ORDERS: function (state, data) {
       state.options.linkedOrders.splice(0, state.options.linkedOrders.length, ...data);
    },

    /**
     * Toggles bluescreen revision details data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_BLUESCREEN_REVISION_DETAILS: function (state, data) {
        state.bluescreenRevisionDetails = data;
    },

    ADD_DRAFT_COMMENT: function (state, data) {
        state.revision.drafts[data.index].comments.push(data.comment);
    },
};
